/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Int64NullableDlmBaseResponse } from '../models/int-64-nullable-dlm-base-response';
import { PressureTestResponseDlmBaseResponse } from '../models/pressure-test-response-dlm-base-response';

@Injectable({
  providedIn: 'root',
})
export class PressureTestService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiPressureTestPressureTestGet
   */
  static readonly ApiPressureTestPressureTestGetPath = '/api/PressureTest/pressure-test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureTestPressureTestGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureTestPressureTestGet$Plain$Response(params?: {
    pressureTestId?: number;
    calibrationId?: number;
  }): Observable<StrictHttpResponse<PressureTestResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureTestService.ApiPressureTestPressureTestGetPath, 'get');
    if (params) {
      rb.query('pressureTestId', params.pressureTestId, {});
      rb.query('calibrationId', params.calibrationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PressureTestResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureTestPressureTestGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureTestPressureTestGet$Plain(params?: {
    pressureTestId?: number;
    calibrationId?: number;
  }): Observable<PressureTestResponseDlmBaseResponse> {

    return this.apiPressureTestPressureTestGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<PressureTestResponseDlmBaseResponse>) => r.body as PressureTestResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureTestPressureTestGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureTestPressureTestGet$Json$Response(params?: {
    pressureTestId?: number;
    calibrationId?: number;
  }): Observable<StrictHttpResponse<PressureTestResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureTestService.ApiPressureTestPressureTestGetPath, 'get');
    if (params) {
      rb.query('pressureTestId', params.pressureTestId, {});
      rb.query('calibrationId', params.calibrationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PressureTestResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureTestPressureTestGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPressureTestPressureTestGet$Json(params?: {
    pressureTestId?: number;
    calibrationId?: number;
  }): Observable<PressureTestResponseDlmBaseResponse> {

    return this.apiPressureTestPressureTestGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<PressureTestResponseDlmBaseResponse>) => r.body as PressureTestResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiPressureTestPressureTestPost
   */
  static readonly ApiPressureTestPressureTestPostPath = '/api/PressureTest/pressure-test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureTestPressureTestPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureTestPressureTestPost$Plain$Response(params?: {
    calibrationId?: number;
    body?: Array<number>
  }): Observable<StrictHttpResponse<Int64NullableDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureTestService.ApiPressureTestPressureTestPostPath, 'post');
    if (params) {
      rb.query('calibrationId', params.calibrationId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Int64NullableDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureTestPressureTestPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureTestPressureTestPost$Plain(params?: {
    calibrationId?: number;
    body?: Array<number>
  }): Observable<Int64NullableDlmBaseResponse> {

    return this.apiPressureTestPressureTestPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Int64NullableDlmBaseResponse>) => r.body as Int64NullableDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPressureTestPressureTestPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureTestPressureTestPost$Json$Response(params?: {
    calibrationId?: number;
    body?: Array<number>
  }): Observable<StrictHttpResponse<Int64NullableDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PressureTestService.ApiPressureTestPressureTestPostPath, 'post');
    if (params) {
      rb.query('calibrationId', params.calibrationId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Int64NullableDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPressureTestPressureTestPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPressureTestPressureTestPost$Json(params?: {
    calibrationId?: number;
    body?: Array<number>
  }): Observable<Int64NullableDlmBaseResponse> {

    return this.apiPressureTestPressureTestPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Int64NullableDlmBaseResponse>) => r.body as Int64NullableDlmBaseResponse)
    );
  }

}
